import * as React from 'react'
import {
  useLoadingStore,
  selectLoading,
} from '@/modules/shared/stores/loadingStore'
import { LoaderIcon } from '@/app/features/icons/Loader'
import DriverContractRow from './DriverContractRow'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import { TableHeader } from '@/modules/drivers/shared/tableItems/TableHeader'
import TableEmpty from '@/modules/drivers/shared/tableItems/TableEmpty'
import { getDriversContractColumns } from '@/modules/drivers/constants/tables'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useDate } from '@/modules/drivers/stores/dateStore'
//import { useQueryDriverBillingPresence } from '@/modules/billing/api/useQueryDriverBillingPresence'

interface DriversContractTableProps {
  drivers: any[]
  companyId?: string
}

const currentPeriod = (): string => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

const DriversContractTable: React.FC<DriversContractTableProps> = ({
  drivers,
  companyId,
}) => {
  const { t } = useLocalize()
  const columns = getDriversContractColumns(t)
  const loading = useLoadingStore(selectLoading)
  const { search, hasMore, loadMore, isLoadingMore } = useDrivers()

  const { month } = useDate()
  const period = month ?? currentPeriod()
  // const { data: presenceMap } = useQueryDriverBillingPresence(
  //   companyId ?? null,
  //   period,
  // )

  const scrollContainerRef = React.useRef<HTMLDivElement>(null)
  const sentinelRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const sentinel = sentinelRef.current
    if (!sentinel) return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMore()
        }
      },
      { root: scrollContainerRef.current, threshold: 0.1 },
    )

    observer.observe(sentinel)
    return () => observer.disconnect()
  }, [loadMore])

  return (
    <section className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">
      {loading && drivers.length === 0 ? (
        <div className="tw-grid tw-place-items-center">
          <LoaderIcon className="tw-w-16 tw-animate-spin" />
        </div>
      ) : drivers.length > 0 ? (
        <div ref={scrollContainerRef} className="tw-h-full tw-overflow-y-auto">
          <table className="tw-relative tw-w-full tw-table-auto tw-border-spacing-x-2">
            <TableHeader
              opacity
              rounded={false}
              disabledCheckboxToggle
              columns={columns}
              sortConfig={null}
              sticky
              onHeaderClick={undefined}
            />
            <tbody className="">
              {drivers.map((item) => {
                //const presence = presenceMap?.get(item.id)
                //const isCounted =
                //  item.isActive === true ||
                //  Boolean(
                //    presence &&
                //      (presence.hasTimesheet ||
                //        presence.hasImport ||
                //        presence.hasPrintout),
                //  )
                return (
                  <DriverContractRow
                    search={search}
                    key={item.id}
                    driver={item}
                    //isCounted={isCounted}
                  />
                )
              })}
            </tbody>
          </table>
          {hasMore && (
            <div
              ref={sentinelRef}
              className="tw-flex tw-justify-center tw-py-4"
            >
              {isLoadingMore && (
                <LoaderIcon className="tw-w-8 tw-animate-spin" />
              )}
            </div>
          )}
        </div>
      ) : (
        <>
          <table className="tw-relative tw-w-full tw-table-auto tw-border-spacing-x-2">
            <TableHeader
              opacity
              disabledCheckboxToggle
              columns={columns}
              sortConfig={null}
            />
          </table>
          <TableEmpty
            title={
              !search
                ? t('driverModule.no-drivers-selected')
                : t('common.no-search-results')
            }
          />
        </>
      )}
    </section>
  )
}

export default DriversContractTable
